import { object, string } from 'yup';
import { MATCHER_NO_SPECIAL_SYMBOLS_REGEX } from './MatcherNoSpecialCharactersRegex';
import { FieldErrors } from 'react-hook-form';

export interface MatcherNameStepFields {
  first_name: string;
  last_name: string;
}

const matcherFullNameInfoSchema = object().shape({
  first_name: string()
    .trim()
    .required('Please enter your first name.')
    .min(2, 'Please enter two or more characters for your first name.')
    .max(40, 'Please enter 40 characters or less for your first name.')
    .matches(
      MATCHER_NO_SPECIAL_SYMBOLS_REGEX,
      'Please use only letters (a–z).'
    ),

  last_name: string()
    .trim()
    .required('Please enter your last name.')
    .min(2, 'Please enter two or more characters for your last name.')
    .max(80, 'Please enter 80 characters or less for your last name.')
    .matches(MATCHER_NO_SPECIAL_SYMBOLS_REGEX, 'Please use only letters (a–z).')
});

function consolidateMatcherFirstAndLastNameErrors(
  errors: FieldErrors<MatcherNameStepFields>
): string | undefined {
  const firstError = errors.first_name;
  const lastError = errors.last_name;

  if (firstError?.type === 'required' && lastError?.type === 'required') {
    // When both required errors are present, show a single combined message
    return 'Please enter your first and last name.';
  }

  if (firstError) {
    return firstError.message as string;
  }

  if (lastError) {
    return lastError.message as string;
  }

  return undefined;
}

export { matcherFullNameInfoSchema, consolidateMatcherFirstAndLastNameErrors };
